import { I18nComponente } from "@/types/gerais"

export const OEditarGruposi18n: I18nComponente = {
  "pt-BR": {
    salvarAlteracoes: "salvar alterações",
    cancelar: "cancelar",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    cancelarEdicaoDeGrupo: "cancelar edição de grupo?",
    aoCancelarVocePerderaTodasAsAlteracoesFeitasNoGrupoDeProjetos: "Ao cancelar você perderá todas as alterações feitas no grupo de projetos",
    edicoesSalvasComSucesso: "edições salvas com sucesso",
    noGrupoDeProjetos: "no grupo de projetos",
    erroAoEditarGrupoDeProjetos: "Erro ao editar o grupo de projetos",
    erroAoBuscarOsUsuariosResponsaveis: "Erro ao buscar os usuários responsáveis",
    ocorreuUmErroAoBuscarOsUsuariosResponsaveis: "Ocorreu um erro ao buscar os usuários responsáveis",
  },
  "es-CO": {
    salvarAlteracoes: "guardar cambios",
    cancelar: "cancelar",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    cancelarEdicaoDeGrupo: "¿cancelar edición de grupo?",
    aoCancelarVocePerderaTodasAsAlteracoesFeitasNoGrupoDeProjetos: "Al cancelar perderá todos los cambios realizados en el grupo de proyectos",
    edicoesSalvasComSucesso: "ediciones guardadas con éxito",
    noGrupoDeProjetos: "en el grupo de proyectos",
    erroAoEditarGrupoDeProjetos: "Error al editar el grupo de proyectos",
    erroAoBuscarOsUsuariosResponsaveis: "Error al buscar los usuarios responsables",
    ocorreuUmErroAoBuscarOsUsuariosResponsaveis: "Ocurrió un error al buscar los usuarios responsables",
  }
}
